module.exports = __webpack_public_path__ + "static/media/Mask Group 206.e7ff25b9.png";